import { Badge, makeStyles } from "@fluentui/react-components";
import { BadgeStatusType } from "../../../utils/common/Constants";

interface IStatusDotProps {
  status: BadgeStatusType;
}

const StatusDot: React.FC<IStatusDotProps> = ({ status }) => {
  const classes = useStyles();
  return <Badge color={status} className={classes.dot} />;
};

export default StatusDot;

const useStyles = makeStyles({
  dot: {
    width: "8px",
    height: "8px",
    display: "inline-block",
    padding: "0",
  },
});
